<template>
    <div class="fill-h d-flex flex-column">
        <cookies-modal :showDialog="!$store.getters.cookies"></cookies-modal>
        <div class="bg" style="flex-grow: 1; display: flex; flex-direction: column;">
            <div class="row no-gutters">
                <div class="col-sm-12 col-md-12 col-lg-1 offset-lg-1 flex-column">
                    <div class="mx-auto noselect">
                        <img src="~@/assets/img/logo.png" />
                    </div>
                </div>
            </div>

            <div class="row no-gutters align-items-center justify-content-around" style="flex-grow: 1;">

                <div class="col-sm-10 col-md-12 col-lg-4 flex-column mr-4">
                    <div class="row justify-content-center">
                        <div class="col-auto align-items-left">
                            <p class="text-center extra-bold display-4 noselect">{{ $t('LoginHeadline') }}</p>
                            <p class="text-center regular mt-4 noselect" style="font-size: 1.3rem">{{ $t('LoginSubline') }}</p>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12 col-md-12 col-lg-4 gradient rounded p-5 m-4" style="max-width: 400px;">
                    <div class="d-flex flex-row justify-content-start align-items-center mb-4 w-100">
                        <Button class="p-0" buttonClass="login-button semi-bold" title="SignIn" @onClick="signIn" style="font-size: 24px;"/>
                                <!--
                                v-bind:class="{underlined: loginMode, 'semi-bold': loginMode, 'light': !loginMode}"/>
                            <span class="mx-3 light" style="font-size: 24px; color: white;">{{ $t('or') }}</span>
                        <Button class="align-self-left p-0" buttonClass="login-button" title="SignOn" @onClick="signOn" style="font-size: 24px;"
                                v-bind:class="{ underlined: !loginMode, 'semi-bold': !loginMode, 'light': loginMode}"/>
                                -->
                    </div>
                    <!--
                    <div v-if="!loginMode">
                        <p class="label text-left mt-4 mb-1">{{ $t('FIRST_NAME') }}</p>
                    </div>
                    <div v-if="!loginMode" >
                        <input name="firstName" id="firstName" type="text" v-model="firstName"
                        class="form-control no-radius p-0" :placeholder="$t('EnterFirstName')" maxlength="20" @input="firstNameChange" @blur="firstNameChange"></input>
                        <span v-if="this.firstNameErrorMsg.length != 0" class="error">{{this.firstNameErrorMsg}}</span>
                    </div>
                    <div v-if="!loginMode">
                        <p class="label text-left mt-4 mb-1">{{ $t('LAST_NAME') }}</p>
                    </div>
                    <div v-if="!loginMode" >
                        <input type="text" name="lastName" id="lastName"
                        v-model="lastName" class="form-control no-radius p-0" :placeholder="$t('EnterLastName')" maxlength="20" @input="lastNameChange" @blur="lastNameChange"></input>
                        <span v-if="this.lastNameErrorMsg.length != 0" class="error">{{this.lastNameErrorMsg}}</span>
                    </div>
                                -->
                    <div>
                        <p class="label text-left mt-4 mb-1">{{ $t('E_MAIL') }}</p>
                    </div>
                    <div>
                        <input type="email" name="email" id="email"
                        v-model="email" class="form-control no-radius p-0" :placeholder="$t('EnterEmail')" maxlength="50" @input="emailChange" @blur="emailChange"></input>
                        <span v-if="this.emailErrorMsg.length != 0" class="error">{{this.emailErrorMsg}}</span>
                    </div>
                    <div>
                        <p class="label text-left mt-4 mb-1">{{ $t('PASSWORD') }}</p>
                    </div>
                    <div>
                        <input type="password" name="password" id="password"
                        @keyup.enter="login"
                        v-model="password" class="form-control no-radius p-0" :placeholder="$t('EnterPassword')" maxlength="100" aria-describedby="password-help-block" @input="passwordChange" @blur="passwordChange"></input>
                        <span v-if="this.passwordErrorMsg.length != 0" class="error">{{this.passwordErrorMsg}}</span>
                    </div>
                    <!--
                    <div v-if="!loginMode" >
                        <p class="label text-left mt-4 mb-1">{{ $t('CONFIRM_PASSWORD') }}</p>
                    </div>
                    <div v-if="!loginMode" >
                        <input type="password" name="passwordConfirm" id="passwordConfirm"
                        class="form-control no-radius p-0" :placeholder="$t('ConfirmYourPassword')" v-model="passwordConfirm" maxlength="100" aria-describedby="password-help-block"
                         @input="passwordConfirmChange"
                        @blur="passwordConfirmChange"></input>
                        <span class="glyphicon glyphicon-remove form-control-feedback"></span>
                        <span v-if="this.passwordConfirmErrorMsg.length != 0" class="error">{{this.passwordConfirmErrorMsg}}</span>
                    </div>
                    <div v-if="!loginMode" class="d-flex flex-row">
                        <div class="d-flex flex-row align-items-center mt-4">
                            <CheckBox class="mb-2 mr-4" @change="termsOfServiceChange"></CheckBox>
                            <span class="regular mt-1 ml-1 shaded" style="font-size: 12px;">{{ $t('IAgreeStatements') }}</span>
                            <Button class="underlined mt-1" buttonClass="login-button regular" title="TermsOfService" style="font-size: 12px;"/>
                        </div>
                        <span v-if="this.termsOfServiceErrorMsg.length != 0" class="error">{{this.termsOfServiceErrorMsg}}</span>
                    </div>
                    -->
                    <div class="d-flex flex-column my-1 pt-3">
                        <div class="d-flex flex-row mb-1">
                            <Button class="px-3 py-3 mt-3" buttonClass="semi-bold confirm-button flex-grow-1" :title="confirmTitle" @onClick="confirm"/>
                            <Button class="align-self-center underlined" buttonClass="login-button regular" title="AlreadyMember"
                            v-if="!loginMode" @onClick="loginMode = true" style="font-size: 12px;"/>
                        </div>
                        <div class="d-flex flex-row mb-1" style="justify-content: center;">
                            <span v-for="item in serverErrors" class="error" :key="item">{{item}}</span>
                        </div>
                    </div>
                </div>

            </div>

            <div class="d-flex flex-row justify-content-between">
                <div class="ml-md-5">
                    <p class="text-left regular" style="font-size: 12px">Copyright {{(new Date).getYear() + 1900}} @ BioControl</p>
                </div>
                <div class="mr-md-5">
                    <Button title="GdprPrivacyPolicy" class="regular login-button mr-3" @onClick="openPolicy" style="font-size: 12px"/>
                    <Button title="CookiePolicy" class="regular login-button"  style="font-size: 12px"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Button from '@/components/Button.vue'
    import CheckBox from '@/components/CheckBox.vue'
import CookiesModal from '../components/CookiesModal.vue'

    export default {
        props: {
        },
        components: {
            Button,
            CheckBox,
            CookiesModal
        },
        mounted() {
          const token = localStorage.getItem('token')
          if (token) {
            this.$router.push('/systems')
          }
        },
        data() {
            return {
                loginMode: true,
                firstName: '',
                lastName: '',
                email: '',
                password: '',
                passwordConfirm: '',
                termsOfService: true,
                firstNameErrorMsg: '',
                lastNameErrorMsg: '',
                emailErrorMsg: '',
                passwordErrorMsg: '',
                passwordConfirmErrorMsg: '',
                termsOfServiceErrorMsg: '',
                serverErrors: []
            }
        },
        computed: {
            confirmTitle() {
                return this.loginMode ? "SignIn" : "SignOn";
            },
        },
        methods: {
            signIn() {
                this.resetValues()
                this.loginMode = true;
            },
            signOn() {
                this.resetValues()
                this.loginMode = false;
            },
            resetValues() {
                this.firstName = ''
                this.lastName = ''
                this.email = ''
                this.password = ''
                this.passwordConfirm = ''
                this.termsOfService = false
                this.firstNameErrorMsg = ''
                this.lastNameErrorMsg = ''
                this.emailErrorMsg = ''
                this.passwordErrorMsg = ''
                this.passwordConfirmErrorMsg = ''
                this.termsOfServiceErrorMsg = ''
                this.serverErrors = []
            },
            confirm() {
                if (this.loginMode === true) {
                    this.isEmailValid()
                    this.isPasswordValid()
                    this.isPasswordConfirmValid()
                    if(this.emailErrorMsg.length === 0
                       && this.passwordErrorMsg.length === 0)
                    {
                        this.login();
                    }
                } else {
                    this.isEmailValid()
                    this.isPasswordValid()
                    this.isPasswordConfirmValid()
                    this.isFirstNameValid()
                    this.isLastNameValid()
                    if(this.emailErrorMsg.length === 0
                       && this.passwordErrorMsg.length === 0
                       && this.firstNameErrorMsg.length === 0
                       && this.lastNameErrorMsg.length === 0
                       && this.passwordConfirmErrorMsg.length === 0)
                    {
                        this.register();
                    }
                }
            },
            login() {
                var user = {
                    Password: this.password,
                    Email: this.email
                }

                this.$store.dispatch('login', user)
                       .then(() => this.$router.push('/systems'))
                       .then(() => {
                           this.$router.push('/systems')
                       })
                       .catch((error) => {
                            this.serverErrors = [this.$t('LoginIncorrect')];
                        //    console.log(error)
                           if(error == 'Unauthorized access'){
                               this.serverErrors = [this.$t('UnauthorizedRole')]
                           } else {
                               this.serverErrors = [this.$t('LoginIncorrect')];
                           }

                        })
            },
            register() {
                var user = {
                    FirstName: this.firstName,
                    LastName: this.lastName,
                    Password: this.password,
                    Email: this.email
                }

                this.$store.dispatch('register', user)
                   .then(() => this.$router.push('/main'))
                   .catch((error) => {
                        this.serverErrors = error.response.data.map(m => m.description);
                    })
            },
            emailChange(value) {
                this.email = value.target.value;
                this.isEmailValid();
            },
            isEmailValid() {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                var isEmail = re.test(String(this.email).toLowerCase());

                if(this.email.length === 0) {
                    this.emailErrorMsg = this.$t('EmailRequired')
                } else if(!isEmail) {
                    this.emailErrorMsg = this.$t('EmailInvalid')
                } else {
                    this.emailErrorMsg = ''
                }
            },
            passwordChange(value){
                this.password = value.target.value;
                this.isPasswordValid();
            },
            isPasswordValid() {
                var mediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");
                var isPassword = mediumRegex.test(String(this.password).toLowerCase());
                if(this.password.length === 0) {
                    this.passwordErrorMsg = this.$t('PasswordRequired')
                } else if(!isPassword && !this.loginMode) {
                    this.passwordErrorMsg = this.$t('PasswordRules')
                } else {
                    this.passwordErrorMsg = ''
                }
            },
            passwordConfirmChange(value) {
                this.passwordConfirm = value.target.value;
                this.isPasswordConfirmValid();
            },
            isPasswordConfirmValid() {
                if(this.passwordConfirm.length === 0) {
                    this.passwordConfirmErrorMsg = this.$t('ConfirmPasswordRequired')
                } else {
                    this.passwordConfirmErrorMsg = ''
                }
            },
            firstNameChange(value) {
                this.firstName = value.target.value;
                this.isFirstNameValid();
            },
            isFirstNameValid() {
                if(this.firstName.length === 0) {
                    this.firstNameErrorMsg = this.$t('FirstNameRequired')
                } else {
                    this.firstNameErrorMsg = ''
                }
            },
            lastNameChange(value) {
                this.lastName = value.target.value;
                this.isLastNameValid();
            },
            isLastNameValid() {
                if(this.lastName.length === 0) {
                    this.lastNameErrorMsg = this.$t('LastNameRequired')
                } else {
                    this.lastNameErrorMsg = ''
                }
            },
            termsOfServiceChange() {
                this.termsOfService = !this.termsOfService;
                this.isTermsOfServiceValid();
            },
            isTermsOfServiceValid() {
                if(this.termsOfService === false) {
                    this.termsOfServiceErrorMsg = this.$t('Required')
                } else {
                    this.termsOfServiceErrorMsg = '';
                }
            },
            openPolicy(){
                this.$router.push({name: 'policy'})
            }
        }
    }
</script>

<style scoped>

    .gradient {
        background-image: linear-gradient(#31929f, #356a86);
    }

    .label {
        font-family: 'Open Sans', sans-serif !important;
        font-style: normal !important;
        font-weight: 600 !important;
        font-size: 0.8rem !important;
        color: white;
    }

    p {
        color: white;
    }

    .underlined {
        text-decoration: underline;
    }

    .bold {
      font-weight: bold;
    }

    .bg {
      text-align: center;
      background-color: white;
      background-image: url('~@/assets/img/cows.jpg');
      background-size: cover;
      background-repeat: no-repeat;
      background-position: left top;
    }

    .error {
        text-align: left !important;
        color: #FD8282;
        font-size: 11px;
        font-weight: bold;
        font-family: 'Open Sans', sans-serif !important;
        font-style: normal !important;
        font-weight: 400 !important;
    }

    input {
        background: transparent;
        border: none;
        border-bottom: 1px solid white;
        padding-left: 0;
        font-size: 1rem;
        font-family: 'Open Sans', sans-serif !important;
        font-style: normal !important;
        font-weight: 400 !important;
        padding-left: 10px;
        color: #ADD0D7;
    }

    input:focus {
        background: transparent;
        border: none;
        border-bottom: 1px solid white;
        padding-left: 0;
        font-size: 1rem;
        font-family: 'Open Sans', sans-serif !important;
        font-style: normal !important;
        font-weight: 400 !important;
        padding-left: 10px;
        color: #ADD0D7;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    textarea:-webkit-autofill,
    textarea:-webkit-autofill:hover,
    textarea:-webkit-autofill:focus,
    select:-webkit-autofill,
    select:-webkit-autofill:hover,
    select:-webkit-autofill:focus {
        border: 0px solid green;
        -webkit-text-fill-color: #ADD0D7;
        -webkit-box-shadow: 0 0 0px 0px transparent inset;
        transition: background-color 5000s ease-in-out 0s;
        border-bottom: 1px solid white;
    }

    input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: rgb(166, 194, 205);
    }

    .footer {
        position: absolute;
        bottom: 0;
    }

    .lightColor {
        color: rgb(142, 171, 185);
        background: rgb(142, 171, 185);
    }

    .themeColor {
        color: rgb(51, 123, 145);
        background: rgb(51, 123, 145);
    }

    .rounded {
        border-radius:.75rem !important;
    }

    .no-radius {
        border-radius: 0;
    }

    .confirm-button {
        color: white;
        background: rgb(143, 209, 170);
        border-radius: 30px;
        border: none;
        font-size: 15px;
    }

    .login-button {
        color: white;
        background: transparent;
        border: none;
    }

    .noselect {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

</style>



// WEBPACK FOOTER //
// src/views/Login.vue